export default __webpack_public_path__ + "878b764c55b0b4e8e94f9bbb86a2ae24.svg";